const defaults = {
  placeholder: '', // Text of the placeholder of select
  empty: null,     // Text of the empty option, if null no empty otion added
  value: 'value',  // the identifier to take for the value attribute of the select's option
  label: 'label',  // the identifier to take for the html of the select's option
};

/**
 * Add select options to the given select element
 *
 * @param   {object} select        - Element from document.
 * @param   {array}  selectOptions - Collection of select's options to attach to the given select element
 * @param   {hash}   _options      - Configuration options
 */
export function populateOptions(select, selectOptions=[], _options={}) {

  const options = Object.assign({}, defaults, _options);
  select.innerHTML = '';
  if (options.placeholder != '')
    select.innerHTML += '<option value="" disabled selected>'+options.placeholder+'</option>';
  if (options.empty) {
    const emptySelected = (options.placeholder != '') ? '' : 'selected' ;
    select.innerHTML += '<option value="" ' + emptySelected + '>'+options.empty+'</option>';
  }
  selectOptions.forEach ( selectOption => {
    select.innerHTML += '<option value="'+selectOption[options.value]+'">'+selectOption[options.label]+'</option>';
  });
};



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/select_helper.js